module.exports = __webpack_public_path__ + "img/admins.511c3d5a.svg";